import { random, size } from 'lodash';

import {
  CreateGroupInput,
  GroupColor,
  GroupContentApprovalType,
  GroupIcon,
  GroupIconColor,
} from 'api';

const randomNumberColor = random(0, size(GroupColor) - 1);
const randomNumberIconColor = random(0, size(GroupIconColor) - 1);
const randomNumberIcon = random(0, size(GroupIcon) - 1);

export const CREATE_GROUP_INITIAL_VALUES: CreateGroupInput = {
  title: '',
  content_approval_type: GroupContentApprovalType.Auto,
  allow_user_posts: true,
  read_only: false,
  color: Object.values(GroupColor)[randomNumberColor],
  icon_color: Object.values(GroupIconColor)[randomNumberIconColor],
  icon: Object.values(GroupIcon)[randomNumberIcon],
  location_id: null,
  department_id: null,
  is_private: false,
};

export { GroupListFollow } from './components/GroupsIndex';
